module.exports = __webpack_public_path__ + "static/media/tinkio-cover.6de001f7.jpg";